export const FLOW_V2_INCLUDE_WELCOME_SCREEN = 'Include Welcome Screen FLOW_V2';
export const FLOW_V2_WELCOME_SCREEN_HEADING = 'Welcome Screen Heading';
export const FLOW_V2_WELCOME_SCREEN_BODY = 'Welcome Screen Body';
export const FLOW_V2_WELCOME_SCREEN_FOOTER = 'Welcome Screen Footer';
export const FLOW_V2_WELCOME_SCREEN_BUTTON = 'Welcome Screen Button';

export const FLOW_V2_DATA_CHECK_SELECT_DIFF_ID_MESSAGE = 'Data Check Select Different ID Message';
export const FLOW_V2_DATA_CHECK_SELECT_DIFF_ID_EXIT_MESSAGE =
  'Data Check Select Different ID Exit Message';
